/** @jsx jsx */
import { Box, Link } from '@bottlebooks/gatsby-theme-base';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { jsx } from 'theme-ui';

/**
 * @type {React.FC<{paths: object, isScrolledDown?: boolean, locale: string}>}
 */
const MainMenu = React.memo(function MainMenu({
  paths,
  isScrolledDown = false,
  locale,
  ...rest
}) {
  const menuItems = useMenuQuery({ locale });
  if (!menuItems?.length) return null;
  return (
    <Box sx={{ marginLeft: 'auto' }} {...rest}>
      {menuItems.map((item, index) => (
        <MenuItem key={index} {...item} paths={paths} />
      ))}
    </Box>
  );
});
export default MainMenu;

export function MenuItem({ url, type, name, paths, ...rest }) {
  // If there is no custom URL, use the paths to go to the correct URLs.
  const to = url ? null : paths?.[type] || `/${type}`;
  if (!to && !url) return null;
  return (
    <Link
      to={to}
      href={url}
      variant="menu"
      activeClassName="bb-active"
      sx={{ '&.bb-active': { color: 'primary' } }}
      {...rest}
    >
      {name}
    </Link>
  );
}

export function useMenuQuery({ locale }) {
  const {
    event,
    site: { siteMetadata },
  } = useStaticQuery(query);
  const localeOverride = siteMetadata.locales?.find(
    (metadata) => metadata?.locale === locale
  );
  if (localeOverride?.menuItems) return localeOverride.menuItems;
  const menuItems = siteMetadata.menuItems?.filter(
    (item) => item.name || item.url
  );
  if (menuItems?.length) return menuItems;
  return event?.menuItems;
}

const query = graphql`
  {
    site {
      siteMetadata {
        menuItems {
          name
          type
          url
        }
        locales {
          locale
          menuItems {
            name
            type
            url
          }
        }
      }
    }
    event {
      locale
      menuItems {
        name
        type
        url
      }
    }
  }
`;
